<template>
    <div>
        <div class="padding commonBackground margin-bottom margin-top">
            <span class="font-weight-bold margin-right margin-top">班级:</span>
            <span class="margin-top margin-right cursorSz" :class="classId===item.classId?'select':''"
                  @click="selectClass(item.classId)"
                  style="border: none;margin: 10px;margin-right: 5px!important;"
                  v-for="item in classList" :key="item.classId">
                {{item.className}}
            </span>
        </div>
        <div class="padding commonBackground">
            <el-table :data="tableList" border
                      :header-cell-style="headerCellStyle"
                      :cell-style="{'text-align':'center'}">
                <el-table-column
                        prop="num"
                        label="序号"
                        >
                </el-table-column>
                <el-table-column
                        prop="realName"
                        label="姓名"
                        >
                </el-table-column>
                <el-table-column
                        prop="mobile"
                        label="手机号">
                </el-table-column>
                <el-table-column
                        prop=""
                        label="状态">
                    <template slot-scope="scope">
                        <div>VIP</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="margin-y text-center padding-b">
            <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="pageNum"
                    :page-size="20"
                    :hide-on-single-page="true"
                    layout="prev, pager, next, jumper"
                    :total="totalItem">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import {feeClass, searchFeeStuTable} from "../../config";
    export default {
        name: "listCharges",
        data(){
            return{
                classList:[],
                classId:'',
                tableList:[],
                pageSize:20,
                pageNum:1,
                totalItem:0,
                headerCellStyle: {
                    background: 'rgb(232 248 255)',
                    color: '#666666',
                    fontWeight: 'bolder',
                    textAlign: 'center',
                },
            }
        },
        mounted(){
          this.searchClass();
        },
        methods:{
            handleCurrentChange(){
                this.searchTable();
            },
            //查出班级
            async searchClass(){
                let res=await feeClass();
                if(res.status){
                    console.log(res.data);
                    this.classList=res.data;
                    this.classId=res.data[0].classId;
                    this.searchTable();
                }
            },
            async selectClass(val){
                this.classId=val;
               this.searchTable();
            },
            async searchTable(){
                let res=await searchFeeStuTable(this.classId,this.pageNum,this.pageSize);
                if(res.status){
                    console.log(res.data.data);
                    this.tableList=res.data.data;
                    res.data.data.forEach((val,index)=>{
                        this.tableList[index].num=(index+1);
                    })
                    this.totalItem=res.data.totalRecords;

                }
            }
        },
    }
</script>

<style scoped>

</style>